import { render, staticRenderFns } from "./PartnerProgramCodesSkeleton.vue?vue&type=template&id=7b5a5b48&scoped=true"
import script from "./PartnerProgramCodesSkeleton.vue?vue&type=script&lang=ts"
export * from "./PartnerProgramCodesSkeleton.vue?vue&type=script&lang=ts"
import style0 from "./PartnerProgramCodesSkeleton.vue?vue&type=style&index=0&id=7b5a5b48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5a5b48",
  null
  
)

export default component.exports